import React from 'react';
import { CAP_TABLE_CURRENCY_PAGE } from 'common/constants/currencyPageTypes';
import { useFormat } from 'common/hooks';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { BacksolveTableProps } from './types';

const BacksolveTable = ({ spreadsheets, onChange, deleteColFn, isLedgerTable, workbook }: BacksolveTableProps) => {
  const { backsolveSheet } = spreadsheets;

  const [format] = useFormat({ page: CAP_TABLE_CURRENCY_PAGE, units: REGULAR_UNIT });
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: ScalarSpreadsheet is not typed
    <ScalarSpreadsheet
      {...backsolveSheet}
      id="backsolve-table"
      tableTerms={{ tableSlug: 'backsolve-table' }}
      workbook={workbook}
      onChange={onChange}
      sheet={backsolveSheet}
      displayLegend={false}
      alwaysDisplayLegend={false}
      format={format}
      deleteColumn={deleteColFn}
      isLedgerTable={isLedgerTable}
    />
  );
};

export default BacksolveTable;
